<div id="{{ content.key }}" class="row">
	<div class="col-12 text-center">
		<figure>
			<img [src]="content.attributes.image" (click)="openAlbum(content)"/>
			<figcaption *ngIf="content.attributes.caption">{{ content.attributes.caption }}</figcaption>
		</figure>
	</div>
</div>
